import { BrowserRouter, Route, Routes, useLocation, useNavigate } from 'react-router';
import './App.css';
import LayoutProvider, { LayoutContext } from './context';
import { useCallback, useContext, useEffect, useState } from 'react';
import { CssBaseline, CssVarsProvider, extendTheme } from '@mui/joy';

import { AnimatePresence, motion } from 'framer-motion';
import KanbanDashboard from './pages/KanbanDashboard';
import LKPage from './pages/LKPage';
import KanbanPage from './pages/KanbanPage';
import NotesPage from './pages/NotesPage';
import TasksPage from './pages/TasksPage';
import FinancePage from './pages/FinancePage';
import GuestTasksPage from './pages/GuestTasksPage';
import ShareModal from './components/modals/ShareModal';
import ModalProfile from './components/modals/ModalProfile';



const theme = extendTheme({
  colorSchemes: {
    light: {
      palette: {
        primary: {
          50:  '#f0f0fe',  // почти белый с оттенком
          100: '#e2e3fd',  // soft вариант фон
          200: '#c8cafc',  // hover на soft кнопке
          300: '#a5a8f9',  // outlined бортики
          400: '#868af6',  // промежуточный
          500: '#686DF3',  // основной — все solid варианты
          600: '#5055d9',  // hover на solid
          700: '#3d42c0',  // нажатие на solid
          800: '#2e32a6',  // тёмный акцент
          900: '#20258c',  // самый тёмный
        },
        danger: {
          50: "#fde3e4",
          100: "#facccd",
          200: "#f49999",
          300: "#e0666b",
          400: "#cc3340",
          500: "#c30013",
          600: "#b10011",
          700: "#9e000e",
          800: "#8b000b",
          900: "#780008"
        },
        success: {
          50: "#F6FEF6",
          100: "#E3FBE3",
          200: "#C7F7C7",
          300: "#A1E8A1",
          400: "#51BC51",
          500: "#1F7A1F",
          600: "#136C13",
          700: "#0A470A",
          800: "#042F04",
          900: "#021D02"
        },
        neutral: {
          100: '#f5f7faf8',
          500: '#242424', // Цвет фона для всех вариантов
          600: '#2e2e2e', // Цвет фона при наведении если solid вариант
          700: '#1f1f1f', // Цвет фона для всех вариантов (при нажатии)
        },
      },
    },
  },
  breakpoints: {
    values: {
      xs: 0,
      sm: 600,
      md: 900,
      lg: 1200,
      xl: 1536,
      
      extrasmall: 300,
      small: 500,
      medium: 800,
      large: 1100,
    },
  },
  components: {
    JoyButton: {
      styleOverrides: {
        root: ({ theme }) => ({
          transition: '.2s',
          borderRadius: theme.vars.radius.lg,
          "&:hover": {
            transform: "scale(1.02)"
          }
        })
      }
    },
    JoyTextarea: {
      styleOverrides: {
        root: ({ theme }) => ({
          borderRadius: theme.vars.radius.lg
        })
      }
    },
    JoyInput: {
      styleOverrides: {
        root: ({ theme }) => ({
          borderRadius: theme.vars.radius.lg
        })
      }
    },
    JoySelect: {
      styleOverrides: {
        root: ({ theme }) => ({
          borderRadius: theme.vars.radius.lg
        })
      }
    },
    JoyAutocomplete: {
      styleOverrides: {
        root: ({ theme }) => ({
          borderRadius: theme.vars.radius.lg
        })
      }
    },
    JoyIconButton: {
      styleOverrides: {
        root: ({ theme }) => ({
          borderRadius: theme.vars.radius.lg
        })
      }
    }
  },
});



// const ProtectedRoute = ({ children, allowedRoles, userRole }) => {
//   const navigate = useNavigate();
//   const location = useLocation();

//   useEffect(() => {
//     // Защита от ошибки, если `userRole` нет или это пустой массив
//     if (!userRole || !Array.isArray(userRole) || userRole.length === 0) return;
    
//     // Проверяем, есть ли хотя бы одна роль пользователя в allowedRoles
//     const hasAccess = userRole.some(role => allowedRoles.includes(role));
    
//     if (!hasAccess) {
//       if (!location.key) {
//         navigate("/", { replace: true });
//       }
//     }
    
//     console.log("Allowed roles:", allowedRoles);
//     console.log("User roles:", userRole);
//     console.log("Has access:", hasAccess);
//   }, [location.pathname, allowedRoles, userRole, navigate, location.key]);
      
//   // Проверяем доступ для рендера
//   const hasAccess = Array.isArray(userRole) && userRole.length > 0 && 
//                    userRole.some(role => allowedRoles.includes(role));
  
//   return hasAccess ? children : null;
// };


function AnimatePage() {
  const location = useLocation();
  const navigate = useNavigate();
  const { account } = useContext(LayoutContext);


  // useEffect(() => {
  //   if (account?.position?.includes('surveyor') && location?.pathname != '/chats') {
  //       navigate('/chats', { replace: true });
  //   }
  // }, [account, location]);  

  return (
    <AnimatePresence mode='wait'>
      <Routes location={location} key={location.pathname}>
        {/* Гостевой доступ — без шапки и сайдбара */}
        <Route path="/share/:token" element={<GuestTasksPage />} />

        {/* Основное приложение */}
        <Route path='/' element={<LKPage />}>
          <Route path="" element={<KanbanDashboard />} />
          <Route path="kanban" element={<KanbanPage />} />
          <Route path="notes" element={<NotesPage />} />
          <Route path="tasks" element={<TasksPage />} />
          <Route path="finances" element={<FinancePage />} />
        </Route>
      </Routes>
    </AnimatePresence>
  );
}


function App() {
  return (
    <BrowserRouter>
      <CssVarsProvider
        theme={theme}
      >
        <CssBaseline />
        <LayoutProvider>
          <AnimatePage/>

          <ShareModal />
          <ModalProfile />
        </LayoutProvider>
      </CssVarsProvider>
    </BrowserRouter>
  );
}

export default App;